module.exports = __webpack_public_path__ + "img/course_cover.7292a358.png";